<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>操作日志</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>

    <el-card class="content">
      <div class="navbtn">
        <el-card class="button-content">
          <el-button type="primary" size="small" icon="el-icon-refresh" circle :loading="state" @click="refresh"></el-button>

          <el-button v-if="eggUnlocked" type="danger" size="small" icon="el-icon-delete" :disabled="selectedRows.length === 0" style="margin-left: 10px;" :loading="state" @click="handleBatchDelete">
            批量删除 (已选 {{ selectedRows.length }} 条)
          </el-button>
        </el-card>
      </div>

      <el-table 
        :data="operationList" 
        border 
        style="width: 100%" 
        v-loading="loading" 
        stripe
        @selection-change="handleSelectionChange"
      >
        <!-- 彩蛋触发后显示的多选列 -->
        <el-table-column v-if="eggUnlocked" type="selection" width="55" align="center"></el-table-column>

        <el-table-column prop="action" label="动作" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.action === '登录'" style="color: #0050b3">登录</span>
            <span v-if="scope.row.action === '删除'" style="color: #d80821">删除</span>
            <span v-if="scope.row.action === '创建'" style="color: #237804">创建</span>
            <span v-if="scope.row.action === '修改'" style="color: #ad6800">修改</span>
            <span v-if="scope.row.action === '套餐'" style="color: #e9c710">套餐</span>
            <span v-if="scope.row.action === '多开合并'" style="color: #13c2c2">多开合并</span>
            <span v-if="scope.row.action === '多开转换'" style="color: #B28B67">多开转换</span>
          </template>
        </el-table-column>

        <el-table-column prop="entity" label="实体" width="80"></el-table-column>

        <el-table-column prop="sign" label="标识" width="180"></el-table-column>

        <el-table-column prop="record" label="记录">
          <template slot-scope="scope">
            <el-popover placement="top-start" trigger="hover" popper-class="my-popover">
              <code>
                <div v-if="Array.isArray(scope.row.record)">
                  <span class="code-span" v-for="item in scope.row.record" :key="item" style="margin-left:20px;margin-right:20px">{{item}}</span>
                </div>
                <div v-if="Object.prototype.toString.call(scope.row.record) === '[object Object]'">
                  <span class="code-span">{</span>
                  <span class="code-span" v-for="(item,index) in scope.row.record" :key="index" style="margin-left:20px;margin-right:20px">{{index}}: {{item}}</span>
                  <span class="code-span">}</span>
                </div>
                <div v-if="typeof(scope.row.record)=='string'">
                  <span class="code-span" style="margin-left:20px;margin-right:20px">{{scope.row.record}}</span>
                </div>
              </code>
              <div class="text-record" slot="reference" v-if="scope.row.record">{{ scope.row.record | capitalize }}</div>
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column prop="ip" label="ip" width="180">
          <template slot-scope="scope">
            <el-popover placement="top-start" width="200" trigger="hover" popper-class="my-popover" @hide="close" @show="showpopo(scope.row.ip)">
              <code>{{ip}}</code>
              <span style="color: #1890ff" slot="reference">{{ scope.row.ip }}</span>
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column prop="createDate" label="时间" width="140"></el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="operationHandleSizeChange"
        @current-change="operationHandleCurrentChange"
        :current-page="operationInfo.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="operationInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui'; // 1. 引入 Element 的 MessageBox
export default {
  data() {
    return {
      operationList: [],
      loading: true,
      total: 0,
      operationInfo: {
        query: "",
        pagenum: 1,
        pagesize: 10,
        email: this.$store.state.account,
      },
      state: false,
      ip: "",
      online: 0,
      
      // === 彩蛋相关数据 ===
      eggUnlocked: false,
      selectedRows: [],
      konamiCode: [
        'ArrowUp', 'ArrowUp', 
        'ArrowDown', 'ArrowDown', 
        'ArrowLeft', 'ArrowRight', 
        'ArrowLeft', 'ArrowRight'
      ], // 彩蛋按键序列：上上下下左左右右
      konamiIndex: 0 // 当前匹配到的按键序号
    };
  },
  created() {
    this.getOperation();
  },
  mounted() {
    // 监听全局键盘按下事件
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeDestroy() {
    // 组件销毁前移除监听，防止内存泄漏
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    // 监听键盘按键匹配彩蛋
    handleKeyDown(event) {
      console.log('当前按下的按键:', event.key);
      // 避免在输入框中输入时误触发
      if (['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName)) {
        return;
      }
      // 将按下的有效按键收集到一个数组中（只保留最后 8 位）
      if (!this.pressedKeys) {
        this.pressedKeys = [];
      }
      this.pressedKeys.push(event.key);
      // 如果长度超过了彩蛋序列长度，截取最后几位
      if (this.pressedKeys.length > this.konamiCode.length) {
        this.pressedKeys.shift();
      }
      // 检查当前按键历史是否和秘籍完全一致
      const isMatched = this.konamiCode.every(
        (key, index) => key === this.pressedKeys[index]
      );
      console.log("isMatched=",isMatched);
      if (isMatched) {
        console.log('彩蛋触发！');
        this.triggerEasterEgg();
        this.pressedKeys = []; // 触发后清空，避免重复触发
      }
    },

    // 触发彩蛋效果
    triggerEasterEgg() {
      if (this.eggUnlocked) return;
      this.eggUnlocked = true;
      this.$notify({
        title: '🎉 隐藏彩蛋已解锁！',
        message: '高能模式开启：已开启日志批量删除功能。',
        type: 'success',
        duration: 4000
      });
    },

    // 监听表格勾选变化
    handleSelectionChange(val) {
      this.selectedRows = val;
    },

    // 批量删除选中的数据
    async handleBatchDelete() {
      // console.log('选中的数据:', this.selectedRows);
      if (this.selectedRows.length === 0) return;
      const ids = this.selectedRows.map(item => item._id);
      // console.log('选中的数据ids:', ids);
      this.state = true;
      const result = await this.$http.post('deleteOperations', { ids });
      // console.log("result=",result);
      if (result.data.meta.status !== 200) {
        this.$notify.error({ title: '删除失败', message: result.data.meta.msg });
        this.state = false;
        return;
      }else{
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.state = false;
        this.selectedRows = []
        this.getOperation();
      }
    },

    async getOperation() {
      this.state = true;
      this.loading = true;
      const result = await this.$http.post("getOperation", this.operationInfo);
      console.log("日志result", result);
      
      this.operationList = result.data.data.data.map(element => {
        if (typeof element.record === 'string') {
          if (element.record.indexOf('{') > -1 || element.record.indexOf('[') > -1) {
            try {
              element.record = JSON.parse(element.record);
            } catch (e) {
              // 解析失败维持原状
            }
          }
        }
        return element;
      });
      
      this.total = result.data.data.total;
      this.state = false;
      this.loading = false;
    },
    operationHandleCurrentChange(val) {
      this.operationInfo.pagenum = val;
      this.getOperation();
    },
    operationHandleSizeChange(val) {
      this.operationInfo.pagesize = val;
      this.getOperation();
    },
    refresh() {
      this.getOperation();
    },
    async showpopo(val) {
      let result = window.localStorage.getItem(val);
      if (!result) {
        this.state = true;
        result = await this.$http.post('getIp', { ip: val });
        console.log(result);
        this.state = false;
        if (result.data.meta.status !== 200) {
          return this.$notify.error({ title: '获取失败', message: result.data.msg });
        }
        result = result.data.data;
        window.localStorage.setItem(val, JSON.stringify(result));
      }
      this.ip = result;
    },
    close() {
      this.ip = "";
    }
  },
  filters: {
    capitalize(value) {
      if (Array.isArray(value)) {
        value = value.toString();
        value = value.replace('[', '');
        value = value.replace(']', '');
      }
      return value;
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  margin: 5px;
  .navbtn {
    margin-bottom: 20px;
    .button-content {
      display: flex;
      align-items: center;
    }
  }
  .el-table {
    .text-record {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .el-pagination {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
  }
}
</style>